import { Component, OnInit, ElementRef } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from 'app/auth.service';
import { Rol } from 'app/models/roles-user-model';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: [AuthService]
})
export class NavbarComponent implements OnInit {
    private toggleButton: any;
    private sidebarVisible: boolean;
    public nombre: string;
    public roles: Array<Rol>;
    constructor(public location: Location, private element : ElementRef, private auth: AuthService) {
        this.sidebarVisible = false;
    }

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        this.nombre = localStorage.getItem('nombre');
    }
    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        // console.log(html);
        // console.log(toggleButton, 'toggle');

        setTimeout(function(){
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        // console.log(html);
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };
    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    isHome() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/home' ) {
            return true;
        }
        else {
            return false;
        }
    }

    isAereo() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if(titlee.charAt(0) === '#'){
            titlee = titlee.slice( 1 );
        }
        if( titlee === '/aereo' || titlee === '/home' ) {
            return true;
        }
        else {
            return false;
        }
    }

    isSesionIniciada() {
        if(localStorage.getItem('username') != null){
            this.nombre = localStorage.getItem('nombre');
            return true;
        }else{
            return false;
        }
    }

    userIsPropietario(){
        if(localStorage.getItem('roles') != null){
            this.roles = JSON.parse(localStorage.getItem('roles'));
            var isProp = false;
            this.roles.forEach(x => {
                if(x.Nombre.toUpperCase() == "PROPIETARIO"){
                    isProp = true;
                }
            });
            return isProp;
        }else{
            return false;
        }
    }

    isContacto() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/contacto' ) {
            return true;
        }
        else {
            return false;
        }
    }

    cerrarSesion() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('username');
        localStorage.removeItem('usuarioId');
        localStorage.removeItem('nombre');
        localStorage.removeItem('roles');
        this.auth.logout();
    }
}
